// Remembers which onboarding link (/join/<code>) brought this visitor, so the
// sign-up and their listings can be credited to that staff member — even if
// they come back days later to finish listing. Expires after 30 days.
const KEY = 'spaczo_join_ref';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const CODE_RE = /^[a-z0-9][a-z0-9-]{2,39}$/;

export function saveJoinRef(code) {
  const c = String(code || '').trim().toLowerCase();
  if (!CODE_RE.test(c)) return null;
  try { localStorage.setItem(KEY, JSON.stringify({ code: c, at: Date.now() })); } catch {}
  return c;
}

export function getJoinRef() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!v || !CODE_RE.test(v.code) || Date.now() - v.at > MAX_AGE_MS) return null;
    return v.code;
  } catch {
    return null;
  }
}
